import { IntlShape } from 'react-intl'

export type EquipmentSelectOption = { label: string; value: any }

export type EquipmentRowDraft = {
	serviceTypeId?: number
	serviceTypeName?: string
	technicalAttributeId?: number | string
	technicalAttributeName?: string
	transmissionMediumId?: number | string
	transmissionMediumName?: string
	optionsServiceTypeId?: number
	technicalOptions?: EquipmentSelectOption[]
	transmissionOptions?: EquipmentSelectOption[]
}

export const buildEquipmentRowKey = (rowData: any): string => {
	const id = rowData?.id ?? rowData?.countryName ?? 'unknown'
	const area = rowData?.networkAreaName ?? 'area'
	return `${id}-${area}`
}

export const normalizeToNumber = (value: unknown): number | undefined => {
	if (value === null || value === undefined) {
		return undefined
	}

	if (typeof value === 'number') {
		return Number.isNaN(value) ? undefined : value
	}

	if (typeof value === 'string') {
		const parsed = parseInt(value, 10)
		return Number.isNaN(parsed) ? undefined : parsed
	}

	return undefined
}

export const getServiceTypeOptions = (intl: IntlShape) => [
	{ label: intl.formatMessage({ id: 'COST.SERVICE_TYPE_CAPACITY', defaultMessage: 'Capacidad' }), value: 100000007 },
	{ label: intl.formatMessage({ id: 'COST.SERVICE_TYPE_INTERNET', defaultMessage: 'Internet' }), value: 100000001 },
]

export const createDraftFromRow = (rowData: any, intl: IntlShape): EquipmentRowDraft => {
	const initialServiceTypeId = normalizeToNumber(rowData?.serviceTypeId ?? rowData?.serviceType)
	let serviceTypeId = initialServiceTypeId
	let serviceTypeName = rowData?.serviceTypeName as string | undefined

	if (!serviceTypeId && serviceTypeName) {
		const option = getServiceTypeOptions(intl).find((opt) => opt.label === serviceTypeName)
		serviceTypeId = option?.value
	}

	if (serviceTypeId && !serviceTypeName) {
		const option = getServiceTypeOptions(intl).find((opt) => opt.value === serviceTypeId)
		serviceTypeName = option?.label
	}

	return {
		serviceTypeId,
		serviceTypeName,
		technicalAttributeId: rowData?.technicalAttributeId ?? rowData?.technicalAttribute,
		technicalAttributeName: rowData?.technicalAttributeName,
		transmissionMediumId: rowData?.transmissionMediumId ?? rowData?.transmissionMedium,
		transmissionMediumName: rowData?.transmissionMediumName,
	}
}
